export default async function compressImage(file, initialQuality = 80) {
    return new Promise((resolve, reject) => {
        const $canvas = document.createElement("canvas");
        const imagen = new Image();

        imagen.onload = () => {
          let { width, height } = imagen;

          // Ajustar el tamaño si es más pequeño
          if (width < 1000 || height < 1333) {
            const aspectRatio = width / height;
            const targetAspectRatio = 1000 / 1333;

            if (aspectRatio > targetAspectRatio) {
              width = 1000;
              height = Math.round(1000 / aspectRatio);
            } else {
              height = 1333;
              width = Math.round(1333 * aspectRatio);
            }
          }

          $canvas.width = width;
          $canvas.height = height;
          const ctx = $canvas.getContext("2d");


          ctx?.drawImage(imagen, 0, 0, width, height);

          const adjustQuality = (quality) => {
            return new Promise((resolve, reject) => {
              $canvas.toBlob((blob) => {
                if (!blob) return reject(new Error("Error al generar la imagen"));

                if (blob.size >= 40000 && blob.size <= 60000) {
                  return resolve(blob);
                }

                if (blob.size > 60000 && quality > 10) {
                  return resolve(adjustQuality(quality - 10)); // Reducir calidad
                }

                if (blob.size < 40000 && quality < 100) {
                  return resolve(adjustQuality(quality + 5)); // Aumentar calidad si está muy baja
                }

                resolve(blob);
              }, "image/jpeg", quality / 100);
            });
          };

          adjustQuality(initialQuality)
            .then((finalBlob) => resolve(finalBlob))
            .catch(reject);
        };

        imagen.onerror = (err) => reject(err);
        imagen.src = URL.createObjectURL(file);
      });
}